import React, { useEffect } from 'react';
import { Stack, Typography, Button, Box } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';

import ReportsBackIcon from '../../../../assets/icons/reports-back-icon';
import { DeprovisionedUsersList } from '../../../../components/lists/deprovisioned-users-list';

interface ContextType {
    setReportTitle: (title: string) => void;
    setReportDescText: (desc: string) => void;
}

export const DeprovisionedUsersScreen: React.FC = () => {
    const { setReportTitle, setReportDescText } = useOutletContext<ContextType>();
    const navigate = useNavigate();

    useEffect(() => {
        setReportTitle('Deprovisioned Users');
        setReportDescText(
            'Users removed from your subscription, with the group, team, tags, and device serial they had at the time they were deprovisioned.'
        );
    }, [setReportTitle, setReportDescText]);

    return (
        <Stack>
            <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 56, marginTop: 4 }}>
                <Button
                    variant="outlined"
                    color="inherit"
                    onClick={() => navigate('/reports')}
                    sx={{
                        border: 0,
                        padding: 1,
                        boxShadow:
                            '0 0 2px 0 rgba(145, 158, 171, 0.24),0 16px 32px -4px rgba(145, 158, 171, 0.24)',
                    }}
                >
                    <ReportsBackIcon />
                    <Typography fontWeight={400} fontSize={14} color={'black'} marginLeft={1}>
                        Back
                    </Typography>
                </Button>
            </Box>
            <DeprovisionedUsersList />
        </Stack>
    );
};

export default DeprovisionedUsersScreen;
